// créditos: https://github.com/flaviogf/cmc7/
import Bancos from "./fator";

class Cmc7 {
  constructor(cmc7 = "", fatores = Bancos) {
    if (typeof fatores !== "object") return;
    if (cmc7.length !== 30) return;
    this.cmc7 = cmc7.replace(/\s/g, "");
    this.fatores = fatores;
  }

  get banco() {
    const inicioNumeroBanco = 0,
      fimNumeroBanco = 3;
    return this.cmc7.substring(inicioNumeroBanco, fimNumeroBanco);
  }

  get agencia() {
    const inicioNumeroAgencia = 3,
      fimNumeroAgencia = 7;
    return this.cmc7.substring(inicioNumeroAgencia, fimNumeroAgencia);
  }

  get digitoAgencia() {
    const inicioDigitoAgencia = 7,
      fimDigitoAgencia = 8;
    return this.cmc7.substring(inicioDigitoAgencia, fimDigitoAgencia);
  }

  get numeroCheque() {
    const inicioNumeroCheque = 11,
      fimNumeroCheque = 17;
    return this.cmc7.substring(inicioNumeroCheque, fimNumeroCheque);
  }

  get conta() {
    const inicioNumeroConta = this.fatores[this.banco] + 19,
      fimNumeroConta = 28;
    return isNaN(inicioNumeroConta)
      ? ""
      : this.cmc7.substring(inicioNumeroConta, fimNumeroConta);
  }

  get digitoConta() {
    const inicioDigitoConta = 28,
      fimDigitoConta = 29;
    return this.cmc7.substring(inicioDigitoConta, fimDigitoConta);
  }
}

export default Cmc7;
